import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import affiliateApiClient from '../lib/affiliateApiClient';

export default function AffiliateForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await affiliateApiClient.post('/forgot-password', { email: email.trim() });
    } finally {
      setSubmitting(false);
      setSubmitted(true); // always show the generic message, success or not
    }
  };

  if (submitted) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 text-center">
        <div className="max-w-md">
          <h1 className="text-xl font-semibold text-gray-900 mb-2">Check your email</h1>
          <p className="text-gray-600">If that email has an affiliate account, a reset link is on its way.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <form onSubmit={submit} className="max-w-md w-full bg-white rounded-2xl border border-gray-200 p-8 shadow-sm space-y-4">
        <h1 className="text-2xl font-bold text-gray-900 text-center">Reset your password</h1>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm" />
        </div>
        <button disabled={submitting} className="w-full py-3 bg-indigo-600 text-white rounded-lg font-medium hover:bg-indigo-700 disabled:opacity-50">
          {submitting ? 'Sending...' : 'Send reset link'}
        </button>
        <p className="text-center text-sm text-gray-500">
          <Link to="/affiliate/login" className="text-indigo-600 hover:underline">Back to login</Link>
        </p>
      </form>
    </div>
  );
}
